export const DEFAULT_CONTEXT_MENU_SIZE = '40px';
export const DEFAULT_PAGINATION = {
  paginatable: true,
  showEdgeButtons: true,
  size: 10,
  options: [10, 20, 30],
};
